
import { useNavigate } from 'react-router-dom'

const useFullViewTab = ({ setAdminSet, setMissingDataFieldVisibility, formik }) => {
  const navigate = useNavigate()
  const onClickEdit = (tabName) => {
    navigate(`/tab/${tabName}`)
  }

  const setToDefaultHandler = () => {
    const tabListFormikValue = [...formik.values.tabList]
    for (let i = 0; i < tabListFormikValue.length; i++) {
      tabListFormikValue[i].custom_name = tabListFormikValue[i].default_name
    }
    formik.setValues({ tabList: tabListFormikValue }, false)
    setAdminSet(true)
    setMissingDataFieldVisibility(true)
  }

  const switchGoogleImagePull = () => {
    setAdminSet(prevState => !prevState)
  }

  const switchMissingDataFieldVisibility = () => {
    setMissingDataFieldVisibility(prevState => !prevState)
  }

  return { onClickEdit, switchGoogleImagePull, switchMissingDataFieldVisibility, setToDefaultHandler }
}

export default useFullViewTab
